import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LeadFormModal from '../components/LeadFormModal';
import { asset, LOGO, TIMES_PRIME_LOGO } from '../utils/assets';
import './Home.css';

// The 3D headline is stacked copies of the text: shadow, extrusion steps (deepest first), then the face.
const DEPTH_STEPS = [6, 5, 4, 3, 2, 1];

// One array per row of the logo card. h is the logo's height in design px (see .partner-img).
const PARTNER_ROWS = [
  [
    { key: 'giva', file: 'giva.png', name: 'GIVA', h: 18 },
    { key: 'firstcry', file: 'firstcry.png', name: 'FirstCry', h: 21 },
    { key: 'klook', file: 'klook.png', name: 'Klook', h: 18 },
  ],
  [
    { key: 'igp', file: 'igp.png', name: 'IGP', h: 24 },
    { key: 'vetic', file: 'vetic.png', name: 'Vetic', h: 18 },
  ],
  [
    { key: 'meradoc', file: 'meradoc.png', name: 'MeraDoc', h: 16 },
    { key: 'smaaash', file: 'smaaash.png', name: 'Smaaash', h: 26 },
  ],
];

function BornText() {
  return (
    <>
      <span>BORN TO</span> <span>REWARD</span>
    </>
  );
}

function Home() {
  const navigate = useNavigate();
  const [formOpen, setFormOpen] = useState(false);
  const closeForm = useCallback(() => setFormOpen(false), []);

  return (
    <div className="page">
      <div className="screen">
        <div className="pink-band" />
        <div className="hero">
          <header className="brand-row">
            <img className="daalchini-logo" src={LOGO} alt="Daalchini" />
            <span className="brand-x">X</span>
            <img className="times-prime" src={TIMES_PRIME_LOGO} alt="Times Prime" />
          </header>

          <section className="offer">
            <div className="offer-text">
              <h1 className="born" aria-label="Born to reward">
                <span className="born-layer born-shadow" aria-hidden="true">
                  <BornText />
                </span>
                {DEPTH_STEPS.map((step) => (
                  <span
                    key={step}
                    className={`born-layer born-depth${step === DEPTH_STEPS[0] ? ' born-back' : ''}`}
                    style={{ '--step': step }}
                    aria-hidden="true"
                  >
                    <BornText />
                  </span>
                ))}
                <span className="born-layer born-face" aria-hidden="true">
                  <BornText />
                </span>
              </h1>
              <p className="price">At just ₹10</p>
              <p className="worth">Get Benefits Worth ₹5,000+</p>
            </div>
            <img
              className="machine"
              src={asset('machine.webp')}
              alt="Daalchini vending machine"
              fetchpriority="high"
            />
          </section>

          <div className="partners">
            {PARTNER_ROWS.map((row) => (
              <div className="partner-row" key={row[0].key}>
                {row.map(({ key, file, name, h }) => (
                  <img key={key} className="partner-img" style={{ '--h': h }} src={asset(file)} alt={name} />
                ))}
              </div>
            ))}
          </div>

          <p className="lucky">
            Lucky Winner Gets A Golden Ticket
            <br />
            <b>Worth ₹25,000+</b>
          </p>
        </div>

        <div className="sheet">
          <button className="btn btn-primary" type="button" onClick={() => navigate('/nearby-machines')}>
            <img className="btn-icon" src={asset('location.png')} alt="" />
            FIND MACHINE NEAR YOU
          </button>
          <button className="btn btn-outline" type="button" onClick={() => setFormOpen(true)}>
            <img className="btn-icon" src={asset('phone-callback.png')} alt="" />
            INTERESTED IN VENDING MACHINES
          </button>
          <p className="sheet-note">
            Want vending machine at your office, campus or space?
          </p>
        </div>
      </div>

      <LeadFormModal open={formOpen} onClose={closeForm} />
    </div>
  );
}

export default Home;
